<div class="flex justify-center items-center h-[100vh]">
  <p-progressSpinner
    ariaLabel="loading"
    class="mx-auto"></p-progressSpinner>
</div>
